// extracted by mini-css-extract-plugin
export var cardContainer = "_pm-0";
export var cardHeader = "_pm-2";
export var collapsedState = "_pm-3";
export var dragHandle = "_pm-5";
export var dragHandleIcon = "_pm-6";
export var dragging = "_pm-1";
export var titleArea = "_pm-4";